import { FormEvent, useState } from "react";
import { ArrowRight, Eye, EyeOff, LockKeyhole } from "lucide-react";
import { VoxMark } from "./components";

const DEMO_EMAIL = "demo@usevox.io";
const DEMO_PASSWORD = "UnderstandMyData";

export function Login({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [email, setEmail] = useState(DEMO_EMAIL);
  const [password, setPassword] = useState(DEMO_PASSWORD);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (
      email.trim().toLowerCase() !== DEMO_EMAIL ||
      password !== DEMO_PASSWORD
    ) {
      setError("Those details don't match the demo account.");
      return;
    }
    window.localStorage.setItem("vox-demo-session", "active");
    onAuthenticated();
  }

  return (
    <main className="login-page">
      <section className="login-panel">
        <div className="login-card">
          <div className="login-brand">
            <VoxMark theme="light" />
          </div>
          <div className="login-card__heading">
            <h1>Sign in to Vox</h1>
            <p>Use the demo account details to access Northstar Group.</p>
          </div>
          <form onSubmit={handleSubmit}>
            <label>
              Email address
              <input
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                autoComplete="email"
                required
              />
            </label>
            <label>
              Password
              <div className="password-field">
                <input
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((value) => !value)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOff size={17} /> : <Eye size={17} />}
                </button>
              </div>
            </label>
            {error && (
              <p className="form-error" role="alert">
                {error}
              </p>
            )}
            <button className="primary-button login-submit" type="submit">
              Enter demo <ArrowRight size={16} />
            </button>
          </form>
          <div className="login-card__note">
            <LockKeyhole size={13} />
            <span>Authorised demo access · Simulated organisation</span>
          </div>
        </div>
      </section>
    </main>
  );
}
